import { RoutePath } from 'src/data/Routes';
import type { ToolSection } from 'src/routing/RouteToolSections';

export const REPORTER_SECTIONS = [
  { key: 'reporter-reports', path: '/reports', title: 'Reports', isLeaf: true },
  { key: 'reporter-email', path: '/email', title: 'Email', isLeaf: true },
] as const satisfies readonly ToolSection[];

export type ReporterSectionPath = typeof REPORTER_SECTIONS[number]['path'];

export const REPORTER_SECTION_DEFAULT = RoutePath.REPORTER + REPORTER_SECTIONS[0].path;
